<template>
  <footer class="app-footer custom-footer">
    <span><a href="#">Market Scan</a> &copy; {{ currentYear }}</span>
    <span class="ml-auto"></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  data () {
    return {
      currentYear: new Date().getFullYear(), // 2020
    }
  }
}
</script>

<style>
.custom-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue